import React from 'react';
import { Row, Col } from 'react-bootstrap';


export function CardValidationError({ cardFormError }) {
    return (
        <>
            <Row className="mt-2 mb-3">
                <Col xs={12}>
                    <Col className="d-flex align-items-start rounded-3" style={{ backgroundColor: '#FFE6E6', padding: '5px 10px' }}>
                        <Col xs="auto">
                            <i style={{ fontSize: 20, color: '#CC0000' }} className="bi bi-exclamation-circle-fill"></i>
                        </Col>
                        <Col style={{ paddingLeft: 10, paddingTop: 5 }}>
                            <p style={{ fontSize: 13, fontWeight: 'bold' }}>Please fix the following and try to submit your payment again:</p>
                            {cardFormError.nameOnCard && <p style={{ fontSize: 12 }}>{cardFormError.nameOnCard}</p>}
                            {cardFormError.cardNumber && <p style={{ fontSize: 12 }}>{cardFormError.cardNumber}</p>}
                            {cardFormError.amount && <p style={{ fontSize: 12 }}>{cardFormError.amount}</p>}
                            {cardFormError.expirationDate && <p style={{ fontSize: 12 }}>{cardFormError.expirationDate}</p>}
                            {cardFormError.cvv && <p style={{ fontSize: 12 }}>{cardFormError.cvv}</p>}
                            {cardFormError.address1 && <p style={{ fontSize: 12 }}>{cardFormError.address1}</p>}
                            {cardFormError.state && <p style={{ fontSize: 12 }}>{cardFormError.state}</p>}
                            {cardFormError.postalCode && <p style={{ fontSize: 12 }}>{cardFormError.postalCode}</p>}
                            {cardFormError.email && <p style={{ fontSize: 12 }}>{cardFormError.email}</p>}
                            {cardFormError.receiptEmails && <p style={{ fontSize: 12 }}>{cardFormError.receiptEmails}</p>}
                            {cardFormError.mobileNo && <p style={{ fontSize: 12 }}>{cardFormError.mobileNo}</p>}
                            {cardFormError.threeDs && <p style={{ fontSize: 12 }}>{cardFormError.threeDs}</p>}
                        </Col>
                    </Col>
                </Col>
            </Row>

        </>
    )
}


export function EcheckValidationError({ bankAccountType, echeckFormError }) {
    return (
        <>
            <Row className="mt-2 mb-3">
                <Col xs={12}>
                    <Col className="d-flex align-items-start rounded-3" style={{ backgroundColor: '#FFE6E6', padding: '5px 10px' }}>
                        <Col xs="auto">
                            <i style={{ fontSize: 20, color: '#CC0000' }} className="bi bi-exclamation-circle-fill"></i>
                        </Col>
                        <Col style={{ paddingLeft: 10, paddingTop: 5 }}>
                            <p style={{ fontSize: 13, fontWeight: 'bold' }}>Please fix the following and try to submit your payment again:</p>
                            {echeckFormError.accountNumber && <p style={{ fontSize: 12 }}>{echeckFormError.accountNumber}</p>}
                            {echeckFormError.routingNumber && <p style={{ fontSize: 12 }}>{echeckFormError.routingNumber}</p>}
                            {echeckFormError.amount && <p style={{ fontSize: 12 }}>{echeckFormError.amount}</p>}

                            {echeckFormError.bankAccountType && <p style={{ fontSize: 12 }}>{echeckFormError.bankAccountType}</p>}
                            {echeckFormError.accountType && <p style={{ fontSize: 12 }}>{echeckFormError.accountType}</p>}

                            {(bankAccountType === 'Personal') && (echeckFormError.firstName) && (
                                <><p style={{ fontSize: 12 }}>{echeckFormError.firstName}</p></>)}
                            {(bankAccountType === 'Personal') && (echeckFormError.lastName) && (
                                <><p style={{ fontSize: 12 }}>{echeckFormError.lastName}</p></>)}
                            {(bankAccountType === 'Business') && (echeckFormError.businessName) && (
                                <><p style={{ fontSize: 12 }}>{echeckFormError.businessName}</p></>)}

                            {echeckFormError.address1 && <p style={{ fontSize: 12 }}>{echeckFormError.address1}</p>}
                            {echeckFormError.state && <p style={{ fontSize: 12 }}>{echeckFormError.state}</p>}
                            {echeckFormError.postalCode && <p style={{ fontSize: 12 }}>{echeckFormError.postalCode}</p>}
                            {echeckFormError.email && <p style={{ fontSize: 12 }}>{echeckFormError.email}</p>}
                            {echeckFormError.receiptEmails && <p style={{ fontSize: 12 }}>{echeckFormError.receiptEmails}</p>}
                        </Col>
                    </Col>
                </Col>
            </Row>
        </>
    )
}